module.exports = __webpack_public_path__ + "media/images/video-icon-d70aa3d47d7d83026f8be74730bdbc44.png";